module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_9006.620970a8.png";